import type { FeedItem } from "../../../types/content/feedItem";

import styles from "./ArticleSearchList.module.scss";
import { TeaserCluster } from "../../TeaserCluster/TeaserCluster";
import { SearchError } from "../../Discover/SearchError";
import { FeedItemToTeaser } from "../utils/feedItemToTeaser";

export function ArticleSearchList({
  articles,
  searchQuery,
}: {
  articles?: Array<FeedItem>;
  searchQuery: string;
}) {
  if (!articles || articles.length === 0) {
    return (
      <SearchError
        title={`Det verkar inte finnas några artiklar som matchar din sökning på "${searchQuery}"`}
        text="Försök med ord som kan förekomma i texten eller rubriken."
      />
    );
  }

  return (
    <>
      {articles.map((articleItem, i) => {
        return (
          <div
            key={`article-${articleItem.id}-${i}`}
            className={i !== 0 ? styles.teaserClusterDivider : ""}
          >
            <TeaserCluster
              style={articleItem.style}
              header={articleItem.header}
              footer={null}
              hasCardStyling={false}
              isSmallCluster={true}
            >
              <FeedItemToTeaser
                feedItem={articleItem}
                positionInFeed={i}
                inCluster={false}
              />
            </TeaserCluster>
          </div>
        );
      })}
    </>
  );
}
